firebird.factory('videoEncryptService', [
    '$window',
    '$rootScope',
    'logService',
    'meetingService',
    'videoGlobalService',
    'socketService',
    'attendeeService',
    'helperService',
    'localizationService',
    'growlService',
    'attendeeListService',
    'videoFilterService',
    'notificationService',
    'analyticsWrapperService',
    'subscriptionService',
    'userPairStateService',
    'modalHelperService',
    function (
        $window,
        $rootScope,
        logService,
        meetingService,
        videoGlobalService,
        socketService,
        attendeeService,
        helperService,
        localizationService,
        growlService,
        attendeeListService,
        videoFilterService,
        notificationService,
        analyticsWrapperService,
        subscriptionService,
        userPairStateService,
        modalHelperService
    ) {
        var service = {
            initialize: initialize
        };

        var self;

        const logger = logService.createLoggerWithSource('[videoroomCtrl] videoEncryptService');

        return service;

        function initialize(selfParam) {
            logger.debug('videoroomCtrl: videoEncryptService#initialize');
            self = selfParam;

            if (videoGlobalService.test) {
                $window = videoGlobalService.data.$window;
            }

            // end-to-end encryption via insertable streams

            self.e2ee = false; // when encryption is enabled then this becomes true or 'legacy', and media path is changed to sfu
            self.e2eeWorker = null;
            self.hashCalculatorWorker = null;
            self.hashCalculatorWorkerListeners = null;
            self.e2eeOffset = helperService.getQueryParameter('e2eeOffset') !== 'false';
            self.e2eeAlgorithm = helperService.getQueryParameter('e2eeAlgorithm');

            self.oldVideocodec = null;
            self.oldVideocodecScreen = null;
            self.oldVideocodecFile = null;

            self.oldVirtualBackgroundAvailability = videoFilterService.getIsVideoFiltersAvailable();

            self.oldLayoutPage = false;
            self.oldLayoutPageReuseEnabled = false;

            self.e2eeTalkers = {}; // workaround for audio problem. ANYAM-79017
            // configuration for amount of periods attendee needs to have talking indicator and energyLevel = 0
            // to be reconnected
            self.e2eeTalkersSize = 2;

            self.initE2EE = initE2EE;
            self.e2eeSetupSender = e2eeSetupSender;
            self.e2eeSetupReceiver = e2eeSetupReceiver;
            self.e2eeSetupTransform = e2eeSetupTransform;

            self.e2eeChangeSettings = e2eeChangeSettings;
            self.e2eeChangeVideocodec = e2eeChangeVideocodec;
            self.e2eeChangeVirtualBackgroundAvailability = e2eeChangeVirtualBackgroundAvailability;
            self.e2eeChangeLayoutPageSettings = e2eeChangeLayoutPageSettings;
            self.hideMeetingSettingsModalWindow = hideMeetingSettingsModalWindow;
            self.showEncryptionFailedAlert = showEncryptionFailedAlert;
            self.initializeEncryption = initializeEncryption;
            self.createHashCalculatorWorker = createHashCalculatorWorker;
            self.onVerifyE2EEHash = onVerifyE2EEHash;
            self.sendEnableMeetingEncryption = sendEnableMeetingEncryption;
            self.sendCompareMeetingCryptoKeyHash = sendCompareMeetingCryptoKeyHash;
            self.setCryptoKey = setCryptoKey;
            self.removeMediaPathAudioOnlyVideos = removeMediaPathAudioOnlyVideos;
            self.setRemoteVideosMuted = setRemoteVideosMuted;
            self.updateVideoEnabledState = updateVideoEnabledState;
            self.onMediaPathCheckTalkerActivity = onMediaPathCheckTalkerActivity;
            self.onMediaPathCheckTalkerStats = onMediaPathCheckTalkerStats;
            self.onMediaPathStartPlay = onMediaPathStartPlay;
            self.onMediaPathStopPlay = onMediaPathStopPlay;
            self.onMediaPathTalkerReconnect = onMediaPathTalkerReconnect;
            self.updateE2EEStateIfNeeded = updateE2EEStateIfNeeded;

            self.enableE2EE = enableE2EE;
            self.disableE2EE = disableE2EE;

            self.onE2EEEnabled = onE2EEEnabled;
            self.onE2EEDisabled = onE2EEDisabled;

            self.modalsAvailable = false;
            self.rootSubscription = undefined;

            $rootScope.$on('enable-e2ee', self.enableE2EE);
            $rootScope.$on('disable-e2ee', self.disableE2EE);
            $rootScope.$on('verify-e2ee-hash', self.onVerifyE2EEHash);

            $rootScope.$on('e2ee-enabled', self.onE2EEEnabled);
            $rootScope.$on('e2ee-disabled', self.onE2EEDisabled);

            self.rootSubscription = subscriptionService.createSubscription();
            self.rootSubscription.add(
                userPairStateService.modalsAvailable$.subscribe(next => {
                    self.modalsAvailable = next;
                })
            );
        }

        // will be invoked for joining attendee/host
        function initE2EE() {
            if (meetingService.e2eeEnabled()) {
                logger.log('videoroomCtrl - initE2EE');
                if (self.initializeEncryption()) {
                    if (self.modalsAvailable) {
                        modalHelperService.openConfirmE2eEncryptionKeyModal(true);
                    } else {
                        $rootScope.$broadcast('show-modal', {
                            modalName: 'confirmE2EEncryptionKey',
                            newAttendee: true
                        });
                    }
                }
            } else {
                logger.log('videoroomCtrl - initE2EE: e2ee is not enabled');
            }
        }

        function enableE2EE(e, data) {
            if (!helperService.hasSupportForE2EE()) {
                return;
            }

            if (attendeeListService.getAttendeeCountForE2EECondition() > meetingService.getE2EEMaxUsers()) {
                self.showEncryptionFailedAlert();
                return;
            }

            logger.log('videoroomCtrl - enableE2EE');

            // host started setting up e2ee encryption
            if (self.isHost) {
                var cryptoKey = '' + data.e2eeKey; // treat null as "null"
                var salt = $window.crypto.getRandomValues(new Int16Array(16)).toString('base64');

                self.createHashCalculatorWorker();

                self.hashCalculatorWorkerListeners.enableE2EE = function (payload) {
                    if (!payload.success) {
                        self.showEncryptionFailedAlert();
                        logger.error('enableE2EE', 'error in hashCalculatorWorkerListeners', payload.error);
                        return;
                    }

                    self.sendEnableMeetingEncryption(payload.result.encoded, salt, function (response) {
                        if (response.result) {
                            if (self.initializeEncryption()) {
                                logger.log('videoroomCtrl - enableE2EE: rejoining conference due to e2ee enabled');
                                analyticsWrapperService.eventTrack('Meeting - E2EE - Meeting encryption was enabled');
                                self.e2eeChangeSettings(true);

                                // set video enabled if it was enabled before e2ee
                                self.updateVideoEnabledState();

                                self.rejoinConferenceIfNeeded('e2ee enabled');

                                self.setRemoteVideosMuted(false);

                                self.setCryptoKey(cryptoKey);

                                growlService.show(
                                    localizationService.translate('HEADER.SECURITY.NOTIFICATION.E2EE_ENABLED'),
                                    'success'
                                );
                                notificationService.tryShowDesktopNotification(
                                    localizationService.translate('HEADER.SECURITY.NOTIFICATION.E2EE_ENABLED')
                                );
                            }
                        }
                        logger.log(
                            'videoroomCtrl - enableE2EE: sendEnableMeetingEncryption is finished with code ' +
                                response.result
                        );
                    });
                };

                self.hashCalculatorWorker.postMessage({
                    operation: 'enableE2EE',
                    cryptoKey: cryptoKey,
                    salt: salt
                });
            }
        }

        function onE2EEEnabled(e, data) {
            logger.log('videoroomCtrl - onE2EEEnabled');

            var attendantId = attendeeService.getAttendantId();
            meetingService.setMeetingCryptoKeySaltValue(data.salt);
            // we are gonna show this modal only for attendees and other hosts
            if (!self.isHost || attendantId !== data.attendantId) {
                // kick unsupported attendee (paired or switched to phone)
                var attendee = attendeeListService.findAttendee(attendantId);
                if (attendee && (attendee.switchedToPhone || attendee.phoneMemberId)) {
                    logger.log(
                        'videoroomCtrl - onE2EEEnabled: kick unsupported attendee. ' +
                            'switchedToPhone: ' +
                            attendee.switchedToPhone +
                            '; phoneMemberId: ' +
                            attendee.phoneMemberId
                    );

                    $rootScope.$broadcast('attendee-kicked-v2', { reason: 'e2ee' });
                    return;
                }

                // $window.Janus.initCalled is set to true when we call $window.Janus.init in 'finalizeInit' function.
                // If the deviceSelection modal dialog is shown, then Janus will be initialized after the user click 'JOIN NOW' button.
                if (!$window.Janus.initCalled) {
                    logger.log(
                        'videoroomCtrl - onE2EEEnabled: e2ee key input modal showing prevented because of Janus is not yet initialized'
                    );
                    return;
                }

                if (self.initializeEncryption()) {
                    logger.log('videoroomCtrl - onE2EEEnabled: rejoining conference due to e2ee enabled');

                    self.hideMeetingSettingsModalWindow();
                    self.e2eeChangeSettings(true);

                    // set video enabled if it was enabled before e2ee
                    self.updateVideoEnabledState();

                    self.rejoinConferenceIfNeeded('e2ee enabled');

                    self.setRemoteVideosMuted(false);

                    if (self.modalsAvailable) {
                        modalHelperService.openConfirmE2eEncryptionKeyModal(false);
                    } else {
                        $rootScope.$broadcast('show-modal', {
                            modalName: 'confirmE2EEncryptionKey',
                            newAttendee: false
                        });
                    }
                    notificationService.tryShowDesktopNotification(
                        localizationService.translate('HEADER.SECURITY.NOTIFICATION.E2EE_ENABLED')
                    );
                }
            }
        }

        function disableE2EE() {
            logger.log('videoroomCtrl - disableE2EE');

            if (self.isHost) {
                var msg = {
                    message: 'disable-meeting-encryption',
                    callback: function (response) {}
                };
                socketService.send(msg);
                analyticsWrapperService.eventTrack('Meeting - E2EE - Meeting encryption was disabled');
            }
        }

        function onE2EEDisabled() {
            logger.log('videoroomCtrl - onE2EEDisabled');
            growlService.show(localizationService.translate('HEADER.SECURITY.NOTIFICATION.E2EE_DISABLED'), 'success');
            notificationService.tryShowDesktopNotification(
                localizationService.translate('HEADER.SECURITY.NOTIFICATION.E2EE_DISABLED')
            );
            self.e2ee = false;
            meetingService.setMeetingCryptoKeySaltValue(null);

            if (self.e2eeWorker) {
                self.e2eeWorker.terminate();
                self.e2eeWorker = null;
                meetingService.setE2EEEstablished(false);
            }

            if (self.hashCalculatorWorker) {
                self.hashCalculatorWorker.terminate();
                self.hashCalculatorWorker = null;
            }

            if (self.hashCalculatorWorkerListeners) {
                self.hashCalculatorWorkerListeners = null;
            }

            // $window.Janus.initCalled is set to true when we call $window.Janus.init in 'finalizeInit' function.
            // If the deviceSelection modal dialog is shown, then Janus will be initialized after the user click 'JOIN NOW' button.
            if (!$window.Janus.initCalled) {
                logger.log(
                    'videoroomCtrl - onE2EEDisabled: rejoin conference prevented because of Janus is not yet initialized'
                );
                return;
            }

            self.mediapath = 'sfu-fs';
            logger.log('videoroomCtrl - onE2EEDisabled: rejoining conference due to e2ee disabled');

            self.e2eeChangeSettings(false);
            self.removeMediaPathAudioOnlyVideos();
            self.rejoinConferenceIfNeeded('e2ee disabled');
        }

        function onVerifyE2EEHash(e, data) {
            var cryptoKey = '' + data.e2eeKey; // treat null as "null"
            var salt = meetingService.getMeetingCryptoKeySaltValue();

            self.createHashCalculatorWorker();

            self.hashCalculatorWorkerListeners.onVerifyE2EEHash = function (payload) {
                if (!payload.success) {
                    self.showEncryptionFailedAlert();
                    data.callback(false);
                    logger.error('onVerifyE2EEHash', 'error in hashCalculatorWorkerListeners', payload.error);
                    return;
                }

                self.sendCompareMeetingCryptoKeyHash(payload.result.encoded, function (response) {
                    if (response.result) {
                        self.setCryptoKey(cryptoKey);
                        analyticsWrapperService.eventTrack('Meeting - E2EE - Correct meeting encrypted key submitted');
                    } else {
                        analyticsWrapperService.eventTrack('Meeting - E2EE - Wrong meeting encrypted key submitted');
                    }
                    data.callback(response.result);
                    logger.log(
                        'videoroomCtrl - onVerifyE2EEHash: compare meeting crypto key hash is finished with code ' +
                            response.result
                    );
                });
            };

            self.hashCalculatorWorker.postMessage({
                operation: 'onVerifyE2EEHash',
                cryptoKey: cryptoKey,
                salt: salt
            });
        }

        function e2eeChangeSettings(value) {
            self.e2eeChangeVideocodec(value);
            self.e2eeChangeVirtualBackgroundAvailability(value);
            self.e2eeChangeLayoutPageSettings(value);
        }

        function e2eeChangeVideocodec(value) {
            if (value) {
                self.oldVideocodec = self.videocodec;
                self.oldVideocodecScreen = self.videocodecScreen;
                self.oldVideocodecFile = self.videocodecFile;

                self.videocodec = 'vp8';
                self.videocodecScreen = self.videocodecFile = null;

                logger.log(
                    'videoroomCtrl - e2eeChangeVideocodec: e2ee is on => videocodec changed from ' +
                        self.oldVideocodec +
                        ' to ' +
                        self.videocodec
                );
            } else {
                logger.log(
                    'videoroomCtrl - e2eeChangeVideocodec: e2ee is off => videocodec changed from ' +
                        self.videocodec +
                        ' to ' +
                        self.oldVideocodec
                );

                self.videocodec = self.oldVideocodec;
                self.videocodecScreen = self.oldVideocodecScreen;
                self.videocodecFile = self.oldVideocodecFile;
            }
        }

        function e2eeChangeVirtualBackgroundAvailability(value) {
            if (value) {
                self.oldVirtualBackgroundAvailability = videoFilterService.getIsVideoFiltersAvailable();

                // disable video background in e2ee meeting
                videoFilterService.setIsVideoFiltersAvailable(false);

                logger.log(
                    'videoroomCtrl - e2eeChangeVirtualBackgroundAvailability: e2ee is on => virtual background availability changed from ' +
                        self.oldVirtualBackgroundAvailability +
                        ' to false'
                );
            } else {
                logger.log(
                    'videoroomCtrl - e2eeChangeVirtualBackgroundAvailability: e2ee is off => virtual background availability changed from ' +
                        videoFilterService.getIsVideoFiltersAvailable() +
                        ' to ' +
                        self.oldVirtualBackgroundAvailability
                );

                videoFilterService.setIsVideoFiltersAvailable(self.oldVirtualBackgroundAvailability);
            }
        }

        function e2eeChangeLayoutPageSettings(value) {
            if (value) {
                self.oldLayoutPage = self.layoutPage;
                self.oldLayoutPageReuseEnabled = self.layoutPageReuse.enabled;

                self.layoutPage = false;
                self.layoutPageReuse.enabled = false;

                logger.log(
                    'videoroomCtrl - e2eeChangeLayoutPageSettings: e2ee is on => layoutPage changed from ' +
                        self.oldLayoutPage +
                        ' to ' +
                        self.layoutPage
                );
            } else {
                logger.log(
                    'videoroomCtrl - e2eeChangeLayoutPageSettings: e2ee is off => layoutPage changed from ' +
                        self.layoutPage +
                        ' to ' +
                        self.oldLayoutPage
                );

                self.layoutPage = self.oldLayoutPage;
                self.layoutPageReuse.enabled = self.oldLayoutPageReuseEnabled;
            }
        }

        function hideMeetingSettingsModalWindow() {
            $rootScope.$broadcast('hide-modal', 'meetingSettings');
        }

        function sendCompareMeetingCryptoKeyHash(hashedCryptoKey, callback) {
            var msg = {
                message: 'compare-meeting-crypto-key-hash',
                data: {
                    hash: hashedCryptoKey
                },
                callback: callback
            };
            socketService.send(msg);
        }

        function setCryptoKey(value) {
            if (!self.e2eeWorker) {
                logger.error('setCryptoKey', 'No e2ee worker is instantiated');
                return;
            }

            self.e2eeWorker.postMessage({
                operation: 'setCryptoKey',
                currentCryptoKey: value,
                useCryptoOffset: self.e2eeOffset,
                salt: meetingService.getMeetingCode().replace(/[ -]/g, ''),
                audioCodec: self.audiocodec
            });
            meetingService.setE2EEEstablished(true);
        }

        function sendEnableMeetingEncryption(hash, salt, callback) {
            var msg = {
                message: 'enable-meeting-encryption',
                data: {
                    hash: hash,
                    salt: salt
                },
                callback: callback
            };
            socketService.send(msg);
        }

        function initializeEncryption() {
            logger.log('videoroomCtrl - initializeEncryption: started encryption');
            self.mediapath = 'sfu'; // rest of the code is not affected.
            if (helperService.hasSupportForE2EEModern()) {
                self.e2ee = true;
            } else if (helperService.hasSupportForE2EELegacy()) {
                self.e2ee = 'legacy';
            } else {
                self.e2ee = false;
            }

            if (self.e2ee) {
                var url = '/lib/e2ee/worker.js';

                if (self.e2eeAlgorithm) {
                    url = helperService.setQueryParameter(url, 'algorithm', self.e2eeAlgorithm);
                }

                self.e2eeWorker = new $window.Worker(url, { name: 'E2EE Worker' });
            }

            return self.e2ee && self.e2eeWorker;
        }

        function updateVideoEnabledState() {
            // set video enabled if it was enabled before e2ee
            self.videoEnabled = !attendeeService.getIsVideoMuted();
            // if videoWasEnabled then we need to set videoEnabledFirstTime to false, otherwise there will be black
            // screen instead of properly worked camera
            if (self.videoEnabled && self.videoEnabledFirstTime) {
                self.videoEnabledFirstTime = false;
            }
        }

        // setup publisher side
        function e2eeSetupSender(plugin, stream) {
            if (!plugin.e2eeSenders) {
                plugin.e2eeSenders = [];
            }
            var pc = plugin.webrtcStuff && plugin.webrtcStuff.pc;
            var senders = pc ? pc.getSenders() : [];
            senders.forEach(function (sender) {
                if (plugin.e2eeSenders.indexOf(sender) < 0) {
                    plugin.e2eeSenders.push(sender);
                    self.e2eeSetupTransform('encode', sender);
                }
            });
        }

        // setup subscriber side.
        function e2eeSetupReceiver(plugin, stream) {
            if (!plugin.e2eeReceivers) {
                plugin.e2eeReceivers = [];
            }
            var pc = plugin.webrtcStuff && plugin.webrtcStuff.pc;
            var receivers = pc ? pc.getReceivers() : [];
            receivers.forEach(function (receiver) {
                if (plugin.e2eeReceivers.indexOf(receiver) < 0) {
                    plugin.e2eeReceivers.push(receiver);
                    self.e2eeSetupTransform('decode', receiver);
                }
            });
        }

        // type is encode or decode. item is sender or receiver respectively.
        function e2eeSetupTransform(type, item) {
            if (self.e2ee) {
                var streams =
                    self.e2ee === true
                        ? item.createEncodedStreams()
                        : item.track.kind == 'video'
                        ? item.createEncodedVideoStreams()
                        : item.createEncodedAudioStreams();

                // streams.readableStream and streams.writableStream are used for backward compatibility
                // see https://w3c.github.io/webrtc-insertable-streams/#specification
                self.e2eeWorker.postMessage(
                    {
                        operation: type,
                        readableStream: streams.readable ? streams.readable : streams.readableStream,
                        writableStream: streams.writable ? streams.writable : streams.writableStream
                    },
                    [
                        streams.readable ? streams.readable : streams.readableStream,
                        streams.writable ? streams.writable : streams.writableStream
                    ]
                );
            }
        }

        function showEncryptionFailedAlert() {
            self.showAlert(
                localizationService.translate('COMMON.OOPS_TEXT'),
                localizationService.translate('HEADER.SECURITY.NOTIFICATION.CREATE_PASSWORD_HASH_FAILED')
            );
        }

        function removeMediaPathAudioOnlyVideos() {
            $window.$('#videoroom-videos > div.remote[user].audioonly').each(function (index, element) {
                logger.log(
                    'videoroomCtrl - removeMediaPathAudioOnlyVideos: removing audioonly box for fid=' +
                        element.getAttribute('user')
                );
                self.removeVideoElement(null, element);
            });
        }

        function setRemoteVideosMuted(value) {
            $window.$('#videoroom-videos > div.remote[user] > video').each(function (index, videoElement) {
                logger.log(
                    'videoroomCtrl - setRemoteVideosMuted: fid=' +
                        videoElement.parentElement.getAttribute('user') +
                        '; value=' +
                        value
                );
                videoElement.muted = value;
            });
        }

        function createHashCalculatorWorker() {
            if (!self.hashCalculatorWorker && !self.hashCalculatorWorkerListeners) {
                self.hashCalculatorWorkerListeners = {};

                self.hashCalculatorWorker = new $window.Worker('/lib/e2ee/hashCalculatorWorker.js', {
                    name: 'HashCalculatorWorker'
                });
                self.hashCalculatorWorker.onmessage = function (message) {
                    var operation = self.hashCalculatorWorkerListeners[message.data.operation];
                    if (!operation || typeof operation !== 'function') {
                        logger.error('createHashCalculatorWorker', 'unhandled message from encryption worker');
                        return;
                    }

                    operation(message.data);
                };

                self.hashCalculatorWorker.onerror = function (error) {
                    logger.error('createHashCalculatorWorker', 'HashCalculatorWorker received an error', error);
                    self.showEncryptionFailedAlert();
                };
            }
        }

        function updateE2EEStateIfNeeded() {
            // check e2ee state on server and update client if needed
            logger.log('videoroomCtrl on node reconnected: start checking e2ee state');
            var msg = {
                message: 'meeting-encryption-state',
                callback: function (response) {
                    logger.log(
                        'videoroomCtrl on node reconnected: received e2ee state: ' +
                            response.result +
                            '. Local e2ee state: ' +
                            meetingService.e2eeEnabled()
                    );
                    if (meetingService.e2eeEnabled() !== response.result) {
                        if (response.result === true) {
                            $rootScope.$broadcast('e2ee-enabled', response);
                        } else {
                            $rootScope.$broadcast('e2ee-disabled');
                        }
                    }
                }
            };
            socketService.send(msg);
        }

        // called to detect when talker changes.
        function onMediaPathCheckTalkerActivity() {
            (attendeeListService.getAttendeeList() || []).forEach(function (attendee) {
                if (attendee && attendee.attendantId !== self.attendantId) {
                    var list = self.e2eeTalkers[attendee.attendantId];
                    if (list && list[0]) {
                        if (self.isAttendeeTalking(attendee)) {
                            list[0].talking = true; // whether talked during this interval at all.
                            list[0].last = true; // talking now.
                        } else {
                            list[0].last = false; // not talking anymore.
                        }
                    }
                }
            });
        }

        // called when audio energy stats is captured. It is typically called every 10s, except for first time.
        function onMediaPathCheckTalkerStats(audioEnergy) {
            Object.keys(audioEnergy).forEach(function (attendantId) {
                var energy = audioEnergy[attendantId];
                var list = self.e2eeTalkers[attendantId];
                if (list && list.length === 1) {
                    list.push({ energy: energy }); // first interval did not have any talker data.
                } else if (list && list.length > 0) {
                    list[0].energy = energy;
                    if (list.length > self.e2eeTalkersSize) {
                        list.splice(self.e2eeTalkersSize, list.length - self.e2eeTalkersSize);
                    }
                    var count = list.filter(function (data) {
                        return data.energy === 0 && data.talking;
                    }).length;

                    if (
                        list.length >= self.e2eeTalkersSize &&
                        count === list.length &&
                        meetingService.getE2EEEstablished()
                    ) {
                        logger.warn(
                            'onMediaPathCheckTalkerStats',
                            'videoroom: Detected attendant has potential audio problems',
                            attendantId
                        );
                        // all intervals had talking but no energy. perform reconnect for that attendee.
                        // self.onMediaPathTalkerReconnect(attendantId);
                    }

                    list.splice(0, 0, { talking: list[0].last, last: list[0].last });
                }
            });
        }

        function onMediaPathStartPlay(fid) {
            if (!self.e2eeTalkers[fid]) {
                self.e2eeTalkers[fid] = [{}];
            }
        }

        function onMediaPathStopPlay(fid) {
            if (self.e2eeTalkers[fid]) {
                delete self.e2eeTalkers[fid];
            }
        }

        // TODO: when attendee is removed, then remove from self.e2eeTalkers too. this is impt for reconnections.
        function onMediaPathTalkerReconnect(attendantId) {
            logger.log('videoroom: attempting to re-attach plugin for user: ' + attendantId);
            self.restartVideoPlay(attendantId);
        }
    }
]);
